module.exports = __webpack_public_path__ + "img/pd-img-head4.007afb57.png";